import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/home/ubuntu/download/698587d8921dc90014dd04b1/guzmanrodriguez/src/contexts/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/698587d8921dc90014dd04b1/guzmanrodriguez/src/styles/index.css");
